import { IEKGEvent } from '../store/ekgImport.types'
import { IItem } from '../../timeline/store/timeline.types'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { TimelineConstants } from '../../timeline/store/timeline.constants'
import { IRescueState } from '../../procedures/rescue/store/rescue.types'
import { getUpdatedProcedureStateWithNemsisCode, handleNemsisCodeError } from '../../../utilities/nemsisCode.util'
import { INemsisSnomedLookup } from '../../../components/procedure/store/procedure.types'

interface CreateRescueProcedureProps {
  procedureEvent: IEKGEvent
  ptaCutoff: Date | null
  nemsisCodeOptions: INemsisSnomedLookup[]
}

export interface RescueProcedureObject {
  rescueState: IRescueState
  timelineItem: IItem
}

const createRescueProcedure = (props: CreateRescueProcedureProps): RescueProcedureObject => {
  const { procedureEvent, ptaCutoff, nemsisCodeOptions } = props

  const clientEventId = (procedureEvent.eventVitals.clientEventId as number).toString()
  const vsAction = procedureEvent.eventVitals.vsAction
  const isEkgImport = procedureEvent.eventVitals.isEkgImport

  const itemComments = procedureEvent.procedureComments ?? ''
  const itemSubHeader = `By , Comments: ${itemComments}.`

  const eventDate = new Date(procedureEvent.dtDevice)
  const isPTA = !!ptaCutoff && eventDate < ptaCutoff

  const timelineItem: IItem = {
    key: clientEventId,
    itemType: 'Procedures',
    event: 'Rescue',
    grid: true,
    labelHeaderFlag: isPTA ? 'PTA' : '',
    labelHeader: procedureEvent.eventVitals.time,
    subHeader: procedureEvent.eventVitals.date,
    eventSubHeader: itemSubHeader,
    rowActionType: TimelineConstants.SET_RESCUE_PROCEDURE_ITEM,
    defaultHref: TabConstants.RESCUE_PROCEDURE,
    date: new Date(procedureEvent.dtDevice),
    clientEventId: clientEventId,
    ...(vsAction && { vsAction: vsAction }),
    ...(isEkgImport && { isEkgImport: isEkgImport }),
  }

  let rescueState: IRescueState = {
    key: clientEventId,
    date: procedureEvent.eventVitals.date,
    time: procedureEvent.eventVitals.time,
    rescueTypes: [],
    hydraulics: [],
    tools: [],
    rehab: [],
    activations: [],
    size: '',
    assessedBy: null,
    procedureComplications: [],
    response: null,
    responsePNNV: null,
    authorization: null,
    comments: itemComments,
    addToTimeline: false,
    updateInputRows: false,
    successfulAttempt: true,
    pta: isPTA,
    attempts: '1',
    type: 'Rescue',
    rolePerforming: null,
    rolePerformingPNNV: null,
    isEkgImport: 1,
    nemsisCode: null,
    procedurePerformedByAnotherUnit: null,
    procedurePerformedByAnotherUnitPNNV: null,
  }

  try {
    // Filter based on the activations option (this is how NEMSIS wants it)
    rescueState = getUpdatedProcedureStateWithNemsisCode({
      procedureState: rescueState,
      actionField: null,
      filter1Field: null,
      filter2Field: (s) => (s.activations ? s.activations[0]?.id.toString() : null),
      filter3Field: null,
      nemsisCodeOptions,
    })
  } catch (error: unknown) {
    rescueState = handleNemsisCodeError(error, rescueState)
  }

  const newRescueProcedureObject: RescueProcedureObject = {
    rescueState,
    timelineItem,
  }

  return newRescueProcedureObject
}

export default createRescueProcedure
